import React from 'react';
import { SEVERITY_META } from '@/lib/format';
import { classNames } from '@/lib/format';

export function RiskBadge({ severity, size = 'sm', testId }) {
  const meta = SEVERITY_META[severity] || SEVERITY_META.Informational;
  const cls = classNames(
    'inline-flex items-center gap-1.5 rounded-full font-medium',
    size === 'sm' ? 'text-[10px] px-2 py-0.5 uppercase tracking-wide' : 'text-xs px-2.5 py-1',
    meta.tw
  );
  return (
    <span className={cls} data-testid={testId || 'risk-badge'}>
      <span className="h-1.5 w-1.5 rounded-full bg-white/80" />
      {meta.label}
    </span>
  );
}

export function RiskDot({ severity }) {
  const meta = SEVERITY_META[severity] || SEVERITY_META.Informational;
  return <span className="inline-block h-2 w-2 rounded-full" style={{ background: meta.hex }} />;
}
